<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { useVModel } from '@vueuse/core';
    import { cn } from '../utils';

    const props = withDefaults(
        defineProps<{
            defaultValue?: string | number;
            modelValue?: string | number;
            class?: HTMLAttributes['class'];
            type?: 'text' | 'number' | 'tel' | 'password' | 'email' | 'date';
            maxlength?: number;
        }>(),
        { type: 'text' },
    );

    const emits = defineEmits<{
        'update:modelValue': [string];
    }>();

    const modelValue = useVModel(props, 'modelValue', emits, {
        passive: true,
        defaultValue: props.defaultValue,
    });
</script>

<template>
    <input
        v-model="modelValue"
        data-slot="input"
        :type="type"
        :class="
            cn(
                'h-12 px-4 py-3',
                'bg-background-primary',
                'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground w-full min-w-0 rounded-xl text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50',
                'border border-border-tertiary hover:border-border-secondary',
                'focus-visible:border-border-highlighted focus-visible:ring-border-highlighted focus-visible:ring-2',
                'aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive',
                props.class,
            )
        "
        :maxlength="props.maxlength"
    />
</template>
